<template>
  <v2-card>
    <template #header>
      <h3 class="v2-heading-sm">
        Social Links
      </h3>
    </template>

    <div class="v2-profile-social__grid">
      <!-- Website (required) -->
      <div class="v2-profile-social__field v2-profile-social__field--full">
        <v2-input
          v-model="socialLocal.websiteLink"
          label="Website"
          placeholder="https://www.yourwebsite.com"
          type="url"
          :disabled="isNotEntityAdmin"
          :error="socialLocal.websiteLinkError ? 'Please enter a valid website URL' : ''"
        />
      </div>

      <!-- Twitter -->
      <div class="v2-profile-social__field">
        <v2-input
          v-model="socialLocal.twitterLink"
          label="Twitter"
          placeholder="https://twitter.com/yourhandle"
          type="url"
          :disabled="isNotEntityAdmin"
        />
      </div>

      <!-- Facebook -->
      <div class="v2-profile-social__field">
        <v2-input
          v-model="socialLocal.facebookLink"
          label="Facebook"
          placeholder="https://facebook.com/yourpage"
          type="url"
          :disabled="isNotEntityAdmin"
        />
      </div>

      <!-- Instagram -->
      <div class="v2-profile-social__field">
        <v2-input
          v-model="socialLocal.instagramLink"
          label="Instagram"
          placeholder="https://instagram.com/yourhandle"
          type="url"
          :disabled="isNotEntityAdmin"
        />
      </div>

      <!-- LinkedIn -->
      <div class="v2-profile-social__field">
        <v2-input
          v-model="socialLocal.linkedinLink"
          label="LinkedIn"
          placeholder="https://linkedin.com/company/yourcompany"
          type="url"
          :disabled="isNotEntityAdmin"
        />
      </div>
    </div>

    <!-- Actions -->
    <div class="v2-profile-social__actions">
      <v2-button
        variant="primary"
        :loading="saving"
        :disabled="saving || isNotEntityAdmin"
        @click="onSave"
      >
        Save changes
      </v2-button>
      <v2-button
        variant="outline"
        :disabled="saving"
        @click="onCancel"
      >
        Cancel
      </v2-button>
    </div>
  </v2-card>
</template>

<script>
import { watch } from '@vue/composition-api'
import { useProfileSocial } from '@/composables/useProfileSocial'
import V2Card from '@/components/v2/V2Card.vue'
import V2Button from '@/components/v2/V2Button.vue'
import V2Input from '@/components/v2/V2Input.vue'

export default {
  name: 'V2ProfileSocial',
  components: {
    V2Card,
    V2Button,
    V2Input,
  },
  props: {
    socialData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update-social'],
  setup(props, { emit }) {
    const ps = useProfileSocial()
    ps.initSocial(props.socialData)

    async function onSave() {
      const result = await ps.saveForm()
      if (result?.success) {
        emit('update-social', result.payload)
      }
    }

    function onCancel() {
      ps.resetForm(props.socialData)
    }

    watch(
      () => props.socialData,
      newData => {
        if (newData) {
          ps.initSocial(newData)
        }
      },
    )

    return {
      ...ps,
      onSave,
      onCancel,
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-profile-social {
  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--v2-space-4);
    margin-top: var(--v2-space-4);
    margin-bottom: var(--v2-space-5);
  }

  &__field {
    display: flex;
    flex-direction: column;

    &--full {
      grid-column: 1 / -1;
    }
  }

  &__actions {
    display: flex;
    gap: var(--v2-space-3);
  }

  @media (max-width: 640px) {
    &__grid {
      grid-template-columns: 1fr;
    }

    &__field--full {
      grid-column: 1;
    }
  }
}
</style>
